import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import KnowledgePage from './KnowledgePage';
import Blog from './pages/Blog';


const App = () => {
  // In development, use relative '/api' through the local proxy.
  // In production, connect directly to the live backend.
  const url = process.env.NODE_ENV === 'development' 
    ? (process.env.REACT_APP_API_URL || "/api")
    : (process.env.REACT_APP_API_URL || "https://www.legalfintax.com/api");
  return (
      <Routes>
        <Route path="/" element={<KnowledgePage url={url}/>} />
        <Route path="/knowledge/:slug" element={<Blog url={url}/>} />
      </Routes>
  );
};

export default App;